export const salesInitRoute = {
  path: '/sales-app-init',
  component: 'sa-init',
  componentName: 'Sales App Init',
  theme: 'instaCred',
  template: 'salesApp',
};

export const salesEmiHomeRoute = {
  path: '/sales-emi-home',
  component: 'sa-emi-home',
  componentName: 'Sales EMI Home',
  theme: 'instaCred',
  template: 'salesApp',
};
export const salesLendersListsRoute = {
  path: '/sales-lenders-list',
  component: 'sa-lenders-list',
  componentName: 'Sales Lenders List',
  theme: 'instaCred',
  template: 'salesApp',
};
export const salesLenderDetailsRoute = {
  path: '/sales-lender-details',
  component: 'sa-lender-details',
  componentName: 'Sales Lender Details',
  theme: 'instaCred',
  template: 'salesApp',
};
export const salesSupportRoute = {
  path: '/sales-support',
  component: 'sa-support',
  componentName: 'Sales Support',
  theme: 'instaCred',
  template: 'salesApp',
};

export const salesSessionExpiredRoute = {
  path: '/sales-session-expired',
  component: 'sa-session-expired',
  componentName: 'Sales Session Expired',
  theme: 'instaCred',
  template: 'salesApp',
};

export const salesAgentBlockedRoute = {
  path: '/sales-agent-blocked',
  component: 'sa-agent-blocked',
  componentName: 'Sales Agent Blocked',
  theme: 'instaCred',
  template: 'salesApp',
};

export const SalesAppCommunicationRoute = {
  path: '/sa-communication-screen',
  component: 'sa-communication-screen',
  componentName: 'Communication Component',
  theme: 'instaCred',
  template: 'common',
};

export const salesPreCheckEligibilityRoute = {
  path: '/sa-pre-eligibility-check',
  component: 'sa-pre-eligibility-check',
  componentName: 'Pre Check Eligibility Component',
  theme: 'instaCred',
  template: 'salesApp',
};

export const salesAppRoutes = [
  salesInitRoute,
  salesEmiHomeRoute,
  salesLendersListsRoute,
  salesLenderDetailsRoute,
  salesSupportRoute,
  salesSessionExpiredRoute,
  salesAgentBlockedRoute,
  SalesAppCommunicationRoute,
  salesPreCheckEligibilityRoute,
];



// WEBPACK FOOTER //
// ./alias/salesAppRoutes.js